import { NgModule } from '@angular/core';
import { TranslateDirective } from './translate.directive';
import { TranslatePipe } from './translate.pipe';
import { DefaultTranslateAdapter, TranslateAdapter, TranslateService } from './translate.service';
import * as i0 from "@angular/core";
export class TranslateModule {
    static forRoot(config = {}) {
        return {
            ngModule: TranslateModule,
            providers: [
                config.adapter || {
                    provide: TranslateAdapter,
                    useClass: DefaultTranslateAdapter,
                },
            ],
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateModule, declarations: [TranslateDirective, TranslatePipe], exports: [TranslateDirective, TranslatePipe] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateModule, providers: [TranslateService] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TranslateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TranslateDirective, TranslatePipe],
                    exports: [TranslateDirective, TranslatePipe],
                    providers: [TranslateService],
                }]
        }] });
